<template>
  <div
    class="container-max mx-auto w-full px-4 py-4 text-left md:px-10"
    :class="customClass"
  >
    <div class="mb-4 flex items-center">
      <h3
        v-for="tab in tabOptions"
        :key="tab.title"
        class="mr-6 cursor-pointer capitalize"
        :class="
          currentTab === tab.title
            ? 'border-b-2 border-yellow-500 text-base font-semibold text-yellow-500'
            : 'text-base text-gray-over-dark'
        "
        @click="setTab(tab.title)"
      >
        {{ tab.title }}
        <span v-if="tab.budgeNumber">({{ tab.budgeNumber }})</span>
      </h3>
    </div>
    <div class="mt-8">
      <div
        v-for="tab in tabOptions"
        :key="tab.title"
      >
        <component
          :is="tab.component"
          v-if="currentTab === tab.title"
          :screen-size="screenSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    customClass: {
      type: String,
      default: '',
    },
    tabOptions: Array,
    setHash: {
      type: Function,
      default: () => {},
    },
    defaultTab: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentTab: '',
      screenSize:
        window.innerWidth >= 640
          ? window.innerWidth <= 1024
            ? 'tablet'
            : 'desktop'
          : 'mobile',
    };
  },
  watch: {
    defaultTab: function (val) {
      this.currentTab = val;
    },
  },
  created() {
    if (this.tabOptions?.length > 1) {
      this.currentTab = this.tabOptions[0]?.title;
    }

    addEventListener('resize', () => {
      switch (true) {
        case window.innerWidth <= 640:
          return (this.screenSize = 'mobile');
        case window.innerWidth <= 1024:
          return (this.screenSize = 'tablet');
        default:
          return (this.screenSize = 'desktop');
      }
    });
  },
  methods: {
    setTab(title) {
      this.setHash(title.toLowerCase());
      this.currentTab = title;
    },
  },
};
</script>
